<template>
  <form class="form" @submit.prevent="$emit('submit')" novalidate>
    <div class="body">
      <slot />
    </div>
    <div class="footer">
      <slot name="footer" />
    </div>
  </form>
</template>

<script>
  export default {
    name: "Form"
  };
</script>

<style scoped lang="scss">
  .form {
    display: flex;
    flex-direction: column;

    .body {
      width: 100%;
    }

    .footer {
      margin-top: $gutter;
      display: flex;
      flex-direction: column;
      justify-content: space-around;

      button {
        margin-bottom: $gutter;

        &:last-child {
          margin-bottom: 0;
        }
      }
    }
  }
</style>
